// extracted by mini-css-extract-plugin
export default {"action":"confirmationPopup_action__iW7y2","dialogContainer":"confirmationPopup_dialogContainer__PXBYn","dialogContent":"confirmationPopup_dialogContent__pjYDb"};